import { Icon } from "../../../components/icons";
import { Flex } from "../../../components/layout";
import { colours } from "../../../styles/colours";
import { BlockchainToolsRoutes } from "../../blockchain-tools/routes";
import { KycStatusWidget } from ".././tiles/common";

export const ReportAScamTile = () => (
  <KycStatusWidget
    title="Report a scam:"
    center
    to={BlockchainToolsRoutes.names.reportNew}
  >
    <Flex center>
      <Icon type="reportAScam" colour1={colours.primaryBlue} />
    </Flex>
  </KycStatusWidget>
);
